import WineRegionIcon from './WineRegionIcon';

export default WineRegionIcon;
